export type MatchLayoutAxis = 'vertical' | 'horizontal' | 'auto';
export type MatchLayoutAlignment = 'center' | 'start' | 'end' | 'distribute';

export interface MatchLayoutSettings {
  enabled: boolean;
  axis: MatchLayoutAxis;
  alignment: MatchLayoutAlignment;
}

export const DEFAULT_MATCH_LAYOUT: MatchLayoutSettings = {
  enabled: false,
  axis: 'auto',
  alignment: 'center',
};

const VALID_AXIS: ReadonlySet<MatchLayoutAxis> = new Set<MatchLayoutAxis>([
  'vertical',
  'horizontal',
  'auto',
]);
const VALID_ALIGNMENT: ReadonlySet<MatchLayoutAlignment> = new Set<MatchLayoutAlignment>([
  'center',
  'start',
  'end',
  'distribute',
]);

export function normalizeMatchLayout(raw: unknown): MatchLayoutSettings {
  if (!raw || typeof raw !== 'object') return { ...DEFAULT_MATCH_LAYOUT };
  const r = raw as Record<string, unknown>;
  const axis = typeof r.axis === 'string' && VALID_AXIS.has(r.axis as MatchLayoutAxis)
    ? (r.axis as MatchLayoutAxis)
    : DEFAULT_MATCH_LAYOUT.axis;
  const alignment =
    typeof r.alignment === 'string' && VALID_ALIGNMENT.has(r.alignment as MatchLayoutAlignment)
      ? (r.alignment as MatchLayoutAlignment)
      : DEFAULT_MATCH_LAYOUT.alignment;
  return {
    enabled: r.enabled === true,
    axis,
    alignment,
  };
}
